<script lang="ts" setup>
import { onMounted, usePublish, ref, getCmsSettings, getCurrentUser, logout } from '#imports'
import type { CmsSettings, User } from '../types/cmsTypes'

const { blockPublish, GetPublishStatus, publishIcon, getPublishLabel, publishPage } = usePublish()

const settings = ref<CmsSettings>()
const refreshCmsSettings = async () => {
  const response = await getCmsSettings()
  if (!response.status_ok) {
    return
  }
  settings.value = response.data as CmsSettings
}

const user = ref<User>()

const refreshCurrentUser = async () => {
  const response = await getCurrentUser()
  if (!response.status_ok) {
    return
  }
  user.value = response.data as User
}

onMounted(() => {
  GetPublishStatus()
  refreshCmsSettings()
  refreshCurrentUser()
})
</script>

<template>
  <div class="flex items-stretch h-8 bg-cms-dark-gray gap-3 text-gray-400">
    <div class="flex items-center flex-1">
      <NuxtLink
        v-if="settings?.faviconIco"
        to="/"
        class="flex items-center px-2 text-white font-medium hover:text-cms-blue-hover-menu transition-colors text-admin-menu"
      >
        <NuxtImg
          :src="settings?.faviconIco"
          alt="favico"
          height="24"
          width="24"
          loading="lazy"
          class="object-cover"
          format="webp"
          quality="100"
        />
      </NuxtLink>

      <NuxtLink
        to="/"
        class="hover:bg-cms-dark-gray-hover gap-1.5 h-full flex items-center text-white hover:text-cms-blue-hover-menu transition-colors text-admin-menu px-2"
      >
        <i class="pi pi-home text-sm" />
        {{ settings?.siteName ?? 'Site name' }}
      </NuxtLink>
    </div>

    <div class="flex items-center gap-1">
      <NuxtLink
        to="/"
        class="flex items-center gap-1.5 h-full px-2 hover:bg-cms-dark-gray-hover text-admin-menu hover:text-cms-blue-hover-menu transition-colors"
      >
        <i class="pi pi-external-link text-sm" />
        View site
      </NuxtLink>

      <button
        :disabled="blockPublish"
        :class="blockPublish ? 'cursor-not-allowed' : 'cursor-pointer'"
        class="flex items-center gap-1.5 h-full text-admin-menu px-2 hover:bg-cms-dark-gray-hover hover:text-cms-blue-hover-menu transition-colors text-nowrap"
        @click="publishPage"
      >
        <i :class="publishIcon" />
        {{ getPublishLabel() }}
        <span
          v-if="settings?.unpublished_changes"
          class="text-xs"
        >(obecne nieopublikowane zmiany)</span>
      </button>
      <button
        :class="blockPublish ? 'cursor-not-allowed' : 'cursor-pointer'"
        class="flex items-center gap-1.5 h-full text-admin-menu px-2 hover:bg-cms-dark-gray-hover hover:text-cms-blue-hover-menu transition-colors text-nowrap"
        @click="logout"
      >
        Zalogowano jako: {{ user?.email }}
      </button>
    </div>
  </div>
</template>
